import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import HomePageHeader from "../../components/HomePageHeader";
import HomePageSearchBar from "../../components/HomePageSearchBar";
import HomePageBanner from "../../components/HomePageBanner";
import HomePageFooter from "../../components/HomePageFooter";
import HomePageCatagory from "../../components/HomePageCatagory";
import BestSellingProduct from "../../components/HomePageBestSellProduct";
import RecommentProduct from "../../components/HomePageRecomment";
import styles from "./HomePage.module.css";
import { useCookies } from "react-cookie";
import { getHomeCategories } from "../../apis/categories"; 

export default function HomePage() {
  const [categories, setCategories] = useState([]);
  const [cookies, setCookie] = useCookies(["access_token"]);
  let navigate = useNavigate();

  useEffect(() => {
    if (!cookies.access_token) {
      navigate("/");
    } else {
      const fetchCategories = async () => {
        try {
          const response = await getHomeCategories(cookies.access_token);
          setCategories(response.data.data); 
        } catch (error) {
          console.error("Lỗi khi lấy danh mục:", error);
        }
      };

      fetchCategories();
    }
  }, [cookies.access_token, navigate]);



  const best_selling_product = [
    { productId: "5730bc34-c23b-43dd-8b84-dc40f85a6af8"},
    { productId: "608d53df-5c37-475c-a955-e942584db074"},
    { productId: "93c0a6bd-4a6e-40d2-996b-ab37b9a24234"},
    { productId: "96d9db7f-1885-4bb8-8d80-08a44bf0c5d0"},
    { productId: "adb61da5-64e4-4523-97bb-29251c90edfd"},
    { productId: "b72de8e9-763f-4d6b-9a6d-a2178f4e1632"},
    { productId: "cf29896d-cbab-4458-9197-afbf088cb9ac"},
    { productId: "cfd9e5d5-13cc-4824-a117-ffac8bb67fe0"},

  ];
  const recomment_product = [
    { productId: "217d0e8b-1da8-4c0f-8bfe-a20ffeea749d"},   
    { productId: "608d53df-5c37-475c-a955-e942584db074"},
    { productId: "93c0a6bd-4a6e-40d2-996b-ab37b9a24234"},
    { productId: "96d9db7f-1885-4bb8-8d80-08a44bf0c5d0"},
    { productId: "adb61da5-64e4-4523-97bb-29251c90edfd"},
    { productId: "b72de8e9-763f-4d6b-9a6d-a2178f4e1632"},
    { productId: "cf29896d-cbab-4458-9197-afbf088cb9ac"},
    { productId: "cfd9e5d5-13cc-4824-a117-ffac8bb67fe0"},
  ];

  return (
    <div className={styles.homepage}>
      <div className={styles.nav}>
        <HomePageHeader />
        <HomePageSearchBar />
      </div>
      <div>
        <HomePageBanner />
        <HomePageCatagory categories={categories} />
        <BestSellingProduct best_selling_products={best_selling_product} />
        <RecommentProduct recomment_products={recomment_product} />
      </div>
      <HomePageFooter />
    </div>
  );
}